module.exports = __webpack_public_path__ + "media/alarm.a2db8499.wav";